<template>
  <a
    href="javascript:void(0)"
    :class="isOnboardingRedesign ? `tw-text-[#1A6A72]` : 'text-default'"
    class="text-underline d-inline-block"
    @click="onLinkClick"
  >
    {{ isOnboardingRedesign ? 'Having trouble uploading the photo?' : 'Having Trouble Uploading Photo?' }}

    <b-modal
      id="trouble"
      v-model="showSkipModal"
      hide-header
      hide-footer
      centered
      :content-class="isOnboardingRedesign ? 'tw-bg-white' : 'dark-bg'"
      no-close-on-backdrop
      no-close-on-esc
      no-stacking
    >
      <b-row class="tw-mb-8">
        <b-col cols="12">
          <div
            class="icon-logo"
            :class="isOnboardingRedesign ? 'dark' : 'light'"
          ></div>
        </b-col>
      </b-row>
      <div class="modal-card">
        <p
          class="sub-text"
          style="color: inherit"
        >
          You can skip uploading your photo now but you will need to upload it
          later to verify your identity.
        </p>

        <div class="tw-flex tw-flex-col tw-gap-2">
          <b-button
            variant="info"
            pill
            style="min-width: 100px; width: 100%"
            class="slight-rounded"
            @click="closeModal"
          >
            Upload Now
          </b-button>

          <b-button
            class="modal-cancel-btn slight-rounded"
            variant="outline-info"
            pill
            style="min-width: 100px; width: 100%"
            @click="skip"
          >
            Skip Uploading
          </b-button>
        </div>
      </div>
    </b-modal>
  </a>
</template>

<script>
import { mapState } from 'vuex'
/**
import PersonalPhotoTroubleUpload from '@/components/onboarding/verification/PersonalPhotoTroubleUpload'
 */
export default {
  data() {
    return {
      showSkipModal: false
    }
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign'])
  },
  methods: {
    closeModal() {
      this.$root.$emit('bv::hide::modal', 'trouble');
    },
    skip () {
      this.showSkipModal = false
      this.$emit('skip')
    },
    onLinkClick() {
      if (this.isOnboardingRedesign) {
        this.skip()
      } else {
        this.showSkipModal = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>